import MarkdownIt from "markdown-it";
import mila from "markdown-it-link-attributes";

const HREF = "href";

function markdownitLinkAbsoluteUrls(md: MarkdownIt): void {
    const previousLinkOpen = md.renderer.rules.link_open;
    md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
        const linkOpenToken = tokens[idx];
        const hrefAttrs = linkOpenToken.attrs.filter(
            (attr) => attr[0] === HREF
        );
        const hrefAttr = hrefAttrs.length ? hrefAttrs[0] : null;
        if (hrefAttr) {
            const value = hrefAttr[1];
            if (value) {
                const protocolRegExp = /^.+:\/\//;
                const hasProtocol = protocolRegExp.test(value);
                if (!hasProtocol) {
                    hrefAttr[1] = `http://${value}`;
                }
            }
        }
        return previousLinkOpen(tokens, idx, options, env, self);
    };
}

export default new MarkdownIt({
    html: false,
    linkify: true,
    typographer: false,
})
    .use(mila, {
        attrs: {
            target: "_blank",
        },
    })
    .use(markdownitLinkAbsoluteUrls);
